import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import About from "@/pages/About";

export const Route = createFileRoute("/es/sobre-qbd/")({
  head: () => buildRouteHead("/es/sobre-qbd"),
  component: About,
});

